module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_13.90c7766c.jpg";